export default "__VITE_ASSET__38fc9663__"